/** @jsxImportSource @emotion/react */
import React from "react";
import { Image, Switch, Tooltip, Typography } from "antd";
import dayjs from "dayjs";
import { Images } from "../../common/images";
import * as Styles from "./styles";

export const renderThumbnailCell = (field: string, size: number) =>
  function ThumbnailCell(record: Record<string, unknown>) {
    if (record[field]) {
      return (
        <Image
          width={size}
          height={size}
          src={record[field] as string}
          fallback={Images.DEFAULT_THUMBNAIL}
          placeholder={
            <Image
              preview={false}
              src={Images.DEFAULT_THUMBNAIL}
              width={size}
              height={size}
            />
          }
        />
      );
    }
    return <></>;
  };

export const renderTextTooltipCell = (value: string) => {
  return (
    <Tooltip title={value}>
      <div style={{ width: "100%", display: "block" }}>
        <Typography.Paragraph ellipsis css={Styles.singleTextLineStyle}>
          {value}
        </Typography.Paragraph>
      </div>
    </Tooltip>
  );
};

export const renderArrayStringCell = (value?: string[]) => {
  const newValue = value?.join(", ");
  return (
    <Tooltip title={newValue}>
      <div style={{ width: "100%", display: "block" }}>
        <Typography.Paragraph ellipsis css={Styles.singleTextLineStyle}>
          {newValue}
        </Typography.Paragraph>
      </div>
    </Tooltip>
  );
};

export const renderStatusCell = (field: string) =>
  function StatusCell(record: Record<string, unknown>) {
    return <Switch disabled checked={record[field] as boolean} />;
  };

export const renderDateCell = (value: string) => {
  return dayjs(value).format("DD/MM/YYYY");
};
